module.exports = "/static/assets/de5fcb9a50a24d4b4958026256ee352a.gif";